import { Box, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import "./index.css";
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const BannerPage = () => {
    const [slidesToShow, setSlidesToShow] = useState(1);
    const { template, logo, colors, typography, buttons, banners, preOrderBadgeType, disclaimer } = useSelector((state) => state.template);
    console.log('Loading banner page',banners);
    const navigate = useNavigate();
    const headingsColor = 'var(--headings)';
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 600) {
                setSlidesToShow(1);
            } else if (window.innerWidth <= 960) {
                setSlidesToShow(2);
            } else {
                setSlidesToShow(3);
            }
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    var settings = {
        dots: true,
        infinite: false,
        autoplay: true,
        cssEase: "linear",
        speed: 5000,
        slidesToShow: banners?.numberOfBanners === 1 ? 1 : 3,
        slidesToScroll: banners?.numberOfBanners === 1 ? 1 : 3,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const sliderStyle = {
        margin: '-40px 0px 0 0px',
    };

    if (!banners?.numberOfBanners > 0) return null;

    return (
        <Box style={{ border: 'none' }}>
            <Typography variant="h1" component="h2" sx={{ color: headingsColor, fontSize: "14px", fontWeight: "bold", paddingLeft: '10px' }}> Great Offers!!</Typography>
            <Box className="banner" style={{ border: 'none' }}>
                <Box className="banner__content" >
                    <Slider {...settings} style={sliderStyle}>
                        {banners?.path?.map((path) => (
                            <div style={{ border: 'none', cursor: 'pointer' }} onClick={() => navigate('/products')}>
                                <img style={{ border: 'none', cursor: 'pointer', maxWidth: '350px' }} src={path?.url} alt="Banner" />
                            </div>
                        ))}
                    </Slider>
                </Box>
            </Box>
        </Box>
    );
}

export default BannerPage;
